module.exports = __webpack_public_path__ + "static/img/ChristianPetracca.db54165.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ChristianPetracca.jpg
// module id = 2ZaQ
// module chunks = 0